import request from '@/utils/request'


// 工资条查看
export function viewNoteInfo(params) {
    return request({
        url: '/salary/note/viewNoteInfo',
        headers: {
            isToken: true,
        },
        method: 'get',
        params
    })
}

// 确定工资条
export function confirmNoteInfo(params) {
    return request({
        url: '/salary/note/confirmNoteInfo',
        headers: {
            isToken: true,
        },
        method: 'get',
        params
    })
}